<template>
  <div>
    <ListView
      ref="listView"
      :isFluid="true"
      title="拒收名單"
      @reload="reload"
      @create="actionCreate"
      :search.sync="search"
      :data="data"
      :page.sync="page"
      :header="header"
      :enableCreate="true"
      search-box-placeholder="搜尋電話 / 原因"
      @navDetails="actionDetails"
    >
      <template v-slot:searchBox>
        <v-row dense>
          <v-col cols="12" sm="6" md="2">
            <v-select
              v-model="searchField"
              :items="searchFieldOptions"
              dense
              outlined
              hide-details
              label="搜尋欄位"
              @change="onSearchFieldChange"
            />
          </v-col>
          <v-col cols="12" sm="6" md="3">
            <v-select
              v-if="searchField === 'source'"
              v-model="searchVal"
              :items="sourceSearchOptions"
              dense
              outlined
              hide-details
              label="來源"
              clearable
            />
            <v-text-field
              v-else
              v-model="searchVal"
              dense
              outlined
              hide-details
              :placeholder="searchFieldLabel"
              prepend-inner-icon="mdi-magnify"
              clearable
            />
          </v-col>
        </v-row>
      </template>

      <template v-slot:item.source="{ item }">
        {{ sourceLabel(item.source) }}
      </template>

      <template v-slot:item.createdAt="{ item }">
        {{ item.createdAt | moment('YYYY-MM-DD HH:mm') }}
      </template>

      <template v-slot:item.updatedAt="{ item }">
        {{ item.updatedAt | moment('YYYY-MM-DD HH:mm') }}
      </template>

      <template v-slot:item.actions="{ item }">
        <v-btn icon small color="primary" @click.stop="actionDetails(item)">
          <v-icon small>mdi-pencil</v-icon>
        </v-btn>
      </template>
    </ListView>

    <OptOutDetailsDialog
      v-model="editDialog"
      :id="editId"
      @saved="handleSaved"
      @deleted="handleDeleted"
    />
  </div>
</template>

<script>
import { RESTFUL } from '@/data/constants';
import listViewPageMixin from '@/services/listViewPageMixin';
import OptOutDetailsDialog from '@/components/OptOut/OptOutDetailsDialog';

export default {
  name: 'OptOut',
  components: {
    OptOutDetailsDialog,
  },
  data() {
    return {
      limit: 10,
      header: [
        { text: '電話', value: 'phone' },
        { text: '原因', value: 'reason' },
        { text: '來源', value: 'source' },
        { text: '建立時間', value: 'createdAt' },
        { text: '更新時間', value: 'updatedAt' },
        {
          text: '操作',
          value: 'actions',
          sortable: false,
        },
      ],
      populate: '',
      editDialog: false,
      editId: 'new',
      searchField: 'phone',
      searchFieldOptions: [
        { text: '電話', value: 'phone' },
        { text: '原因', value: 'reason' },
        { text: '來源', value: 'source' },
      ],
      sourceSearchOptions: [
        { text: 'WhatsApp', value: 'whatsapp' },
        { text: '手動', value: 'manual' },
      ],
      sort: { createdAt: -1 },
    };
  },
  mixins: [listViewPageMixin],
  computed: {
    restfulURL() {
      return RESTFUL.optOut.list;
    },
    searchFieldLabel() {
      const field = this.searchFieldOptions.find(f => f.value === this.searchField);
      return field ? `請輸入${field.text}` : '請輸入搜尋內容';
    },
    searchVal: {
      get() {
        return this.search;
      },
      set(val) {
        this.search = val;
      },
    },
    searchPaths() {
      return this.searchField ? [this.searchField] : ['phone', 'reason', 'source'];
    },
  },
  methods: {
    onSearchFieldChange() {
      this.search = '';
    },
    sourceLabel(source) {
      if (source === 'manual') return '手動';
      if (source === 'whatsapp') return 'WhatsApp';
      return source || '';
    },
    actionCreate() {
      this.editId = 'new';
      this.editDialog = true;
    },
    actionDetails(item) {
      this.editId = item._id;
      this.editDialog = true;
    },
    handleSaved() {
      this.reload();
    },
    handleDeleted() {
      this.reload();
    },
  },
};
</script>
